import React from 'react';
import { motion } from 'framer-motion';
import { accessoryCategories } from '../../data/accessories';

const AccessoryCard = ({ accessory, onClick, size = 'default' }) => {
  const categoryConfig = accessoryCategories[accessory.category];
  
  const sizeClasses = {
    small: 'p-3',
    default: 'p-4',
    large: 'p-6'
  };

  const imageSizeClasses = {
    small: 'h-20',
    default: 'h-28',
    large: 'h-36'
  };

  return (
    <motion.div
      whileHover={{ y: -4, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}
      whileTap={{ scale: 0.98 }}
      onClick={() => onClick(accessory)}
      className={`
        bg-white rounded-xl border border-gray-200 cursor-pointer 
        transition-all duration-200 hover:border-primary/30
        ${sizeClasses[size]}
      `}
      data-testid={`accessory-card-${accessory.id}`}
    >
      {/* Category Badge */}
      <span className="inline-block px-2 py-0.5 mb-2 text-[10px] font-semibold text-primary bg-primary/10 rounded-full">
        {categoryConfig.label}
      </span>
      
      {/* Image */}
      <div className={`${imageSizeClasses[size]} flex items-center justify-center mb-3`}>
        <img
          src={accessory.image}
          alt={accessory.name}
          className="max-h-full max-w-full object-contain"
        />
      </div>
      
      {/* Name */}
      <h4 className="font-heading font-semibold text-gray-900 text-sm mb-1 line-clamp-1">
        {accessory.name}
      </h4>
      
      {/* Descriptor */}
      <p className="text-xs text-gray-500 line-clamp-2">
        {accessory.descriptor}
      </p>
      
      {/* Quick View Hint */}
      <div className="mt-3 pt-3 border-t border-gray-100">
        <span className="text-xs text-primary font-medium">
          Quick View →
        </span>
      </div>
    </motion.div>
  );
};

export default AccessoryCard;
